import { useContext, useEffect, useRef } from 'react';

import LayoutContext, { type LayoutType } from '@/context/layout-context';

export default function useLayout(options?: LayoutType) {
  const { layout, setLayout } = useContext(LayoutContext);
  const initialRender = useRef(true);

  useEffect(() => {
    if (initialRender.current) {
      initialRender.current = false;
      return;
    }

    if (options && JSON.stringify(options) !== JSON.stringify(layout)) {
      setLayout(options);
    }
  }, [options, layout, setLayout]);

  return {
    layout,
    setLayout,
  };
}
